export function Clone(obj) {
    const json = JSON.stringify(obj),
        clone = JSON.parse(json);

    return clone;
}